import { createStitches } from '@stitches/react'

export const { styled, css, getCssText, keyframes } = createStitches({})
